import { render, staticRenderFns } from "./personalizacao-item-tile.vue?vue&type=template&id=312566cd&scoped=true&"
import script from "./personalizacao-item-tile.vue?vue&type=script&lang=js&"
export * from "./personalizacao-item-tile.vue?vue&type=script&lang=js&"
import style0 from "./personalizacao-item-tile.vue?vue&type=style&index=0&id=312566cd&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312566cd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('312566cd')) {
      api.createRecord('312566cd', component.options)
    } else {
      api.reload('312566cd', component.options)
    }
    module.hot.accept("./personalizacao-item-tile.vue?vue&type=template&id=312566cd&scoped=true&", function () {
      api.rerender('312566cd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/aawz-intelligence-v2/components/personalizacao-painel/personalizacao-item-tile.vue"
export default component.exports